// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchTypeSelect-module__wrapper___qR13o"};